module.exports = __webpack_public_path__ + "img/video2.2c51a3e9.png";